// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"b2450b8d","132":"24dd5d92","146":"0a62e5e9","158":"97a6cf5c","246":"630bca11","264":"2349b684","453":"feacfc51","699":"c3e5579b","811":"4b3a2614","830":"89e50074","920":"06f727f2","945":"623c38ac"}[chunkId] + ".chunk.js";
};